module.exports = __webpack_public_path__ + "static/media/bannerimg.2fa6b2c2.jpg";